<template>
  <div>
    <loading
        :active.sync="isLoad" 
        :can-cancel="canCancel" 
        :is-full-page="fullPage" 
        :height="height" 
        :width="width" 
        :color="color" 
        :loader="loader" 
        :background-color="bgColor">
    </loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Overlay',
  components: {
    loading: Loading
  },
  data() {
    return {
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: 'dots',
      color: '#003454',
      bgColor: '#00bbe2',
      height: 80,
      width: 80
    }
  },
  computed: {
    isLoad() {
      return this.$store.state.overlayActive
    }
  }
}
</script>